import { render, staticRenderFns } from "./InvestorsDashboard.vue?vue&type=template&id=678f0e37&scoped=true"
import script from "./InvestorsDashboard.vue?vue&type=script&lang=js"
export * from "./InvestorsDashboard.vue?vue&type=script&lang=js"
import style0 from "./InvestorsDashboard.vue?vue&type=style&index=0&id=678f0e37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f0e37",
  null
  
)

export default component.exports